<template>
  <div>
    <div class="row">
      <div class="col-6 col-sm">
        <img :src="`${task.defaultAttachmentUrl}?w=60`" />
      </div>
      <div class="col-6 col-sm">
        
        <div class="mg-b-5">
          <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0">Овог</label>
          <p class="mg-b-0">{{ task.lat }}</p>
        </div>
        <div>
          <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0">Нэр</label>
          <p class="mg-b-0">{{ task.task }}</p>
        </div>
      </div><!-- col -->
      <div class="col-6 col-sm">
        <div class="mg-b-5">
          <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0">Утас</label>
          <p class="mg-b-0">{{ task.mobile }}</p>
        </div>
        <div>
          <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-0">И-мэйл</label>
          <p v-if="task.user!=undefined && task.user!=null" class="mg-b-0">{{ task.user.email }}</p>
        </div>
      </div>
      
      <div class="col-sm mg-t-20 mg-sm-t-0">
        <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Иргэншил</label>
        <p class="mg-b-0">{{ task.locType11FullName }}</p>
      </div>
      <div class="col-sm mg-t-20 mg-sm-t-0">
        <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Төрсөн газар</label>
        <p class="mg-b-0">{{ task.locType2FullName }}</p>
      </div>
      <div class="col-sm mg-t-20 mg-sm-t-0">
        <label :class="`tx-10 tx-medium tx-spacing-1 tx-${obj.isTender?'success':'danger'} tx-uppercase tx-sans mg-b-10`">Шаардлага {{obj.isTender?'хангасан':'хангаагүй'}}</label>
        <div>
          <a @click="saveRealBefore2" class="btn btn-primary btn-xs">Дэлгэрэнгүй харах</a>
        </div>
      </div>
      <!-- <div class="col-sm mg-t-20 mg-sm-t-0">
        <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Төрсөн огноо</label>
        <p class="mg-b-0">{{ task.d1 | moment('YYYY.MM.DD') }}</p>
      </div> -->
    </div>

    <!-- <div>{{ obj.task }}</div> -->
    <!-- <div>{{ obj.organizationTask.task }}</div> -->
    <!-- <div>{{ task.task }}</div> -->
    <div v-for="(b, i) in task.b" :key="i">
      <div class="card mg-b-20 mg-lg-b-25">
        <div
          class="
            card-header bg-light
            pd-y-15 pd-x-20
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <h6 class="tx-uppercase tx-semibold mg-b-0">
            {{ i + 1 }}. {{ b.nm }}
          </h6>
        </div>
        
        <div class="card-body bx-embed-outer pos-relative pd-0">
          <loader
            :ref="`ldr_box_${b.id}`"
            :box="b"
            :prms="{ boxChooser: false }"
            :detailSettingProp="{
              boxSetting: {
                listSetting: { height: 0 },
                hideToolbar: true,
                hideEmptyTemplate: true,
                autoHeight: true,
                hideFooter: true
              },
            }"
            @on-attach="showFile($event)"
            @load-box="loadBoxData"
            @on-detail="showDetail"
          />
        </div>
      </div>
    </div>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      :boxId.sync="taskDialogSide.boxId"
      :parentTask="task"
      @on-task-detail="showDetail"
      @on-task-reload="showDetailForce"
      @on-task-close="taskDialogSide.id = 0"
    ></task-detail-side>

    <b-modal v-model="filledObj.modal" size="lg" centered scrollable title="Шалгуур үзүүлэлтээд" hide-footer>
      <!-- {{filledObj.list}} -->
      <div class="card mg-b-20" v-for="(rb, ri) in filledObj.list" :key="ri">
        <div class="card-header pd-x-10 pd-y-5 bg-gray-100">
        {{ rb.validationInfo.name }}
        </div>
        <div class="card-body">
          <div v-html="rb.htmlInfo"></div>
          <div v-if="!rb.isValid" v-html="rb.msg" :class="`alert alert-${rb.validMsgColor}`"></div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";

import loader from "@/components/box/loader/loader.vue";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

var _ = require("lodash");

export default {
  components:{
    loader,
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return{
      filledObj: {
        list: [],
        isAllValid: false,
        modal: false,
      },
      task: {
        b: []
      },
      taskDialogSide: {
        show: false,
        id: 0,
        key: 0,
        boxId: 0,
      },
    }
  },
  mounted(){
    this.init(this.obj.user.id);
  },
  methods: {
    
    saveRealBefore2(){
      console.log(this.obj);
      request({
        api: { method: "POST", url: "ProjectEdu/CheckDoctorZuvlulRequestValidation" },
        data:{
          requestTaskId: this.obj.id
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.filledObj.list= res.data.list;
          this.filledObj.isAllValid= res.data.isAllValid;
          this.filledObj.modal= true;
        }
      });
    },
    init(userTaskId){
      // this.handleLoading({ isLoading: true });
      request({
        params: { id: userTaskId },
        api: { url: "task/taskInheritedDetail", method: "GET" },
        store: this.$store,
      }).then((res) => {
        // this.handleLoading({ isLoading: false });
        if (res != false) {
          console.log('res', res.data.task);
          this.task= res.data.task;
          this.task.b= _.orderBy(this.task.b.filter(x=> hasOneOf([x.ot], [140, 311, 316, 377, 600]) ), ["ord"], ["asc"]);
        }
      });
    },
    showFile(){},
    loadBoxData(){},
    showDetail(t){
      console.log('t', t);
      this.taskDialogSide.boxId = t.boxId;
      this.taskDialogSide.id = t.id;
    },
  },
};
</script>

<style></style>
